define('plugin/multiple-booking/view/MultipleBookingListView',['require','marionette','plugin/multiple-booking/view/MultipleBookingListItemView','lib/view/UnwrapBehavior'],function (require) {

    var Marionette = require('marionette');
    var MultipleBookingListItemView = require("plugin/multiple-booking/view/MultipleBookingListItemView");
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Multiple booking list view
     *
     * @class MultipleBookingListView
     */
    return Marionette.CompositeView.extend({

        mainTemplate: '#multiple_booking_list_view',
        popupTemplate: '#multiple_booking_popup_list_view',
        cartTemplate: '#multiple_booking_cart_list_view',
        ui: {
            'bookBtn': '#sb_multiple_booking_popup_btn'
        },
        childViewContainer: '#sb_multiple_booking_list',
        childView: MultipleBookingListItemView,
        childViewOptions: function () {
            return {
                'mode': this.getOption('mode')
            };
        },
        collectionEvents: {
            'reset': 'render',
            'remove': 'render',
            'add': 'render'
        },
        triggers: {
            'click @ui.bookBtn': {
                'event': 'submit',
                'stopPropagation': false,
                'preventDefault': false
            }
        },

        getTemplate: function () {
            switch (this.getOption('mode')) {
                case 'popup':
                    return this.popupTemplate;
                case 'cart':
                    return this.cartTemplate;
                default:
                    return this.mainTemplate;
            }
        },

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);
            result.count = this.collection.length;

            return result;
        }

    });

});
